// ── Template definitions & renderers ─────────────────────────────────────────
// Each template: { id, name, icon, desc, defaultConfig, fields[] }
// fields[] describe what the builder shows
// Renderer: React component (inline-styled) used both in builder preview & public page

import React, { useState } from 'react';

export const TEMPLATES = [
  {
    id: 'lead_magnet',
    name: 'Lead Magnet',
    icon: '🎁',
    desc: 'Offrez une ressource gratuite (guide, checklist, promo) en échange d\'un email',
    color: '#6428F4',
    bg: 'linear-gradient(135deg,#6428F4,#C93DB0)',
    defaultConfig: {
      headline: 'Obtenez votre guide gratuit',
      subheadline: 'Rejoignez +500 professionnels qui ont déjà téléchargé notre ressource',
      resource_name: 'Le guide complet',
      description: 'Découvrez les stratégies qui fonctionnent vraiment pour développer votre activité.',
      bullets: ['Applicable immédiatement', 'Exemples concrets et téléchargeable', 'Mis à jour régulièrement'],
      badge_text: 'GRATUIT',
      cta_text: 'Recevoir mon guide gratuit',
      form_title: 'Où dois-je envoyer votre guide ?',
      show_name: true, show_phone: false, show_message: false,
      accent_color: '#6428F4', bg_color: '#F5F3FF',
      company_name: 'Mon entreprise', logo_url: '',
    },
    fields: ['headline','subheadline','resource_name','description','bullets','badge_text','cta_text','form_title','accent_color'],
  },
  {
    id: 'promo',
    name: 'Offre Spéciale',
    icon: '🏷️',
    desc: 'Mettez en avant une promotion, une réduction ou une offre à durée limitée',
    color: '#DC2626',
    bg: 'linear-gradient(135deg,#DC2626,#F59E0B)',
    defaultConfig: {
      headline: 'Offre exclusive — -20% ce mois-ci',
      subheadline: 'Profitez de notre meilleure offre de l\'année avant qu\'il ne soit trop tard',
      discount_text: '-20%',
      validity_text: 'Offre valable jusqu\'au 31 mai 2026',
      description: 'Ne manquez pas cette opportunité unique de bénéficier de nos services à prix réduit.',
      bullets: ['Réduction immédiate sur tous nos services', 'Sans engagement, sans frais cachés', 'Valable pour les nouveaux clients'],
      cta_text: 'Profiter de l\'offre maintenant',
      form_title: 'Réserver ma place',
      show_name: true, show_phone: true, show_message: false,
      accent_color: '#DC2626', bg_color: '#FFF7ED',
      company_name: 'Mon entreprise', logo_url: '',
    },
    fields: ['headline','subheadline','discount_text','validity_text','description','bullets','cta_text','form_title','accent_color'],
  },
  {
    id: 'event',
    name: 'Événement',
    icon: '🎉',
    desc: 'Inscriptions pour un événement, webinaire, atelier ou journée portes ouvertes',
    color: '#0EA5E9',
    bg: 'linear-gradient(135deg,#0EA5E9,#6366F1)',
    defaultConfig: {
      headline: 'Rejoignez-nous pour notre prochain événement',
      subheadline: 'Une matinée pour échanger, apprendre et développer votre réseau',
      event_name: 'Atelier Marketing Digital',
      event_date: '15 juin 2026 — 9h à 12h',
      event_location: 'Paris 8e / En ligne',
      description: 'Venez découvrir les meilleures stratégies marketing adaptées aux PME locales.',
      bullets: ['Places limitées — 20 participants max', 'Interactif et concret', 'Café & networking inclus'],
      cta_text: 'Réserver ma place gratuite',
      form_title: 'S\'inscrire à l\'événement',
      show_name: true, show_phone: false, show_message: false,
      accent_color: '#0EA5E9', bg_color: '#F0F9FF',
      company_name: 'Mon entreprise', logo_url: '',
    },
    fields: ['headline','subheadline','event_name','event_date','event_location','description','bullets','cta_text','form_title','accent_color'],
  },
  {
    id: 'diagnostic',
    name: 'Diagnostic Gratuit',
    icon: '🔍',
    desc: 'Proposez un audit, un diagnostic ou une consultation gratuite pour capturer des leads qualifiés',
    color: '#059669',
    bg: 'linear-gradient(135deg,#059669,#0EA5E9)',
    defaultConfig: {
      headline: 'Obtenez votre diagnostic gratuit',
      subheadline: 'En 30 minutes, découvrez les opportunités cachées dans votre activité',
      offer_name: 'Audit marketing offert',
      description: 'Notre expert analyse votre situation et vous remet un plan d\'action personnalisé — sans engagement.',
      bullets: ['Analyse complète de votre présence digitale', 'Recommandations personnalisées', 'Plan d\'action concret en main propre'],
      cta_text: 'Demander mon diagnostic gratuit',
      form_title: 'Réserver votre créneau',
      show_name: true, show_phone: true, show_message: true,
      message_placeholder: 'Décrivez brièvement votre activité et vos défis actuels…',
      accent_color: '#059669', bg_color: '#F0FDF4',
      company_name: 'Mon entreprise', logo_url: '',
    },
    fields: ['headline','subheadline','offer_name','description','bullets','cta_text','form_title','accent_color'],
  },
  {
    id: 'concours',
    name: 'Concours / Jeu',
    icon: '🎁',
    desc: 'Organisez un tirage au sort pour capturer un maximum de participants — nom, date de naissance, adresse : de quoi enrichir votre base et fêter chaque anniversaire',
    color: '#C026D3',
    bg: 'linear-gradient(135deg,#C026D3,#F59E0B)',
    defaultConfig: {
      headline: 'Tentez de gagner notre grand concours 🎁',
      subheadline: 'Un tirage au sort parmi tous les participants — participez en 30 secondes',
      prize_name: 'Un bon d\'achat de 200 CHF',
      prize_value: '200 CHF',
      prize_image_url: '',
      end_text: 'Tirage au sort le 30 juin 2026',
      description: 'Laissez-nous vos coordonnées pour participer. Le gagnant sera contacté par email et téléphone.',
      bullets: ['Participation gratuite et sans engagement', 'Tirage au sort 100% transparent', 'Un seul gagnant, de vraies chances'],
      badge_text: 'JEU-CONCOURS',
      cta_text: 'Je participe au tirage 🍀',
      form_title: 'Remplissez le formulaire pour participer',
      rules: 'Conditions de participation : jeu gratuit et sans obligation d\'achat, ouvert aux personnes de 18 ans révolus (ou avec accord d\'un représentant légal). Une seule participation par personne pendant la durée du jeu. Le gagnant est désigné par tirage au sort dans les 7 jours suivant la clôture, puis contacté personnellement par e-mail (et par téléphone si nécessaire). Le lot est à retirer sur place dans les 30 jours suivant l\'annonce, sur présentation de l\'e-mail de confirmation ; il n\'est ni échangeable, ni convertible en espèces. Sans retrait dans le délai, un nouveau tirage peut être effectué. Les données collectées sont traitées conformément à la loi suisse sur la protection des données (nLPD), utilisées uniquement par l\'organisateur et jamais transmises à des tiers ; désinscription possible en tout temps. Tout recours juridique est exclu. Organisateur responsable du jeu : voir le nom en haut de page.',
      pickup_info: 'Le lot est à retirer sur place, sur présentation de l\'e-mail de confirmation, dans les 30 jours.',
      consent_participation_text: 'J\'accepte le règlement du jeu et l\'utilisation de mes données pour gérer ma participation et le tirage au sort.',
      consent_email_text: 'J\'accepte de recevoir les actualités, offres et attentions (dont mon anniversaire) par e-mail. Désinscription possible à tout moment.',
      consent_sms_text: 'J\'accepte de recevoir des offres occasionnelles par SMS. Stop à tout moment.',
      birthdate_year_optional: true,
      reward_all_enabled: false,
      reward_all_text: 'Une petite attention vous attend en magasin — montrez ce code !',
      winners_count: 1,
      success_message: 'Votre participation est bien enregistrée — bonne chance pour le tirage ! 🍀',
      show_name: true, show_birthdate: true, birthdate_required: true,
      show_phone: true, show_address: true, show_message: false,
      accent_color: '#C026D3', bg_color: '#FDF4FF',
      company_name: 'Mon entreprise', logo_url: '',
    },
    fields: ['headline','subheadline','prize_name','prize_value','end_text','description','bullets','badge_text','cta_text','prize_image_url','form_title','rules','pickup_info','consent_participation_text','consent_email_text','consent_sms_text','reward_all_text','accent_color'],
  },
];

export function getTemplate(id) {
  return TEMPLATES.find(t => t.id === id) || TEMPLATES[0];
}

// ── Shared form component used in template renderers ─────────────────────────
export function LandingForm({ config, onSubmit, submitting, success, preview }) {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName]   = useState('');
  const [email, setEmail]         = useState('');
  const [birthDate, setBirthDate] = useState('');
  const [phone, setPhone]         = useState('');
  const [address, setAddress]     = useState('');
  const [postalCode, setPostal]   = useState('');
  const [city, setCity]           = useState('');
  const [message, setMessage]     = useState('');
  const [consent, setConsent]     = useState(false);
  const [consentEmail, setConsentEmail] = useState(false);
  const [consentSms, setConsentSms]     = useState(false);
  const [bDay, setBDay]           = useState('');
  const [bMonth, setBMonth]       = useState('');
  const [bYear, setBYear]         = useState('');
  const [err, setErr]             = useState('');
  // Consentements granulaires : actifs dès que la page définit ses textes (concours v2)
  const granular = !!config.consent_participation_text;

  const accent = config.accent_color || '#6428F4';

  if (success) {
    const coupon = typeof success === 'object' ? success.coupon : null;
    const rewardText = typeof success === 'object' ? success.rewardText : null;
    return (
      <div style={{ textAlign: 'center', padding: '32px 24px' }}>
        <div style={{ fontSize: 48, marginBottom: 12 }}>🎉</div>
        <div style={{ fontSize: 20, fontWeight: 800, color: accent, marginBottom: 8 }}>C'est enregistré !</div>
        <div style={{ fontSize: 15, color: '#374151' }}>{config.success_message || 'Merci pour votre participation. Nous revenons vers vous très bientôt.'}</div>
        {typeof success === 'object' && success.referralCode && (
          <div style={{ margin: '18px auto 0', maxWidth: 360, background: '#F5F3FF', border: '1.5px solid #C4B5FD', borderRadius: 14, padding: '14px 18px' }}>
            <div style={{ display: 'flex', justifyContent: 'center', gap: 6, marginBottom: 8 }}>
              {[0, 1, 2, 3, 4].map(i => (
                <span key={i} style={{ width: 30, height: 30, borderRadius: '50%', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontSize: 14, background: i === 0 ? accent : '#fff', border: `2px solid ${i === 0 ? accent : '#E5E7EB'}` }}>🍀</span>
              ))}
            </div>
            <div style={{ fontSize: 12.5, color: '#374151', lineHeight: 1.5, marginBottom: 10 }}>
              <b>1 chance sur 5.</b> Chaque proche qui participe grâce à vous = <b>+1 chance au tirage</b> (maximum 5).
            </div>
            {(() => {
              const link = `${success.shareUrl}?p=${success.referralCode}`;
              const waText = encodeURIComponent(`🎁 Je participe à un jeu-concours — tente ta chance aussi, ça prend 10 secondes : ${link}`);
              return (
                <>
                  <div style={{ background: '#fff', border: `2px dashed ${accent}`, borderRadius: 10, padding: '8px 10px', fontSize: 11, fontWeight: 800, color: accent, wordBreak: 'break-all', marginBottom: 8 }}>
                    🔗 {link}
                  </div>
                  <div style={{ display: 'flex', gap: 7, justifyContent: 'center', flexWrap: 'wrap' }}>
                    <a href={`https://wa.me/?text=${waText}`} target="_blank" rel="noreferrer"
                      style={{ background: '#25D366', color: '#fff', borderRadius: 10, padding: '8px 14px', fontSize: 12, fontWeight: 800, textDecoration: 'none' }}>WhatsApp</a>
                    {typeof navigator !== 'undefined' && navigator.share ? (
                      <button type="button" onClick={() => navigator.share({ url: link, text: '🎁 Tente ta chance au concours !' }).catch(() => {})}
                        style={{ background: '#1877F2', color: '#fff', border: 'none', borderRadius: 10, padding: '8px 14px', fontSize: 12, fontWeight: 800, cursor: 'pointer', fontFamily: 'inherit' }}>Partager</button>
                    ) : null}
                    <button type="button" onClick={() => { navigator.clipboard?.writeText(link); }}
                      style={{ background: '#6B7280', color: '#fff', border: 'none', borderRadius: 10, padding: '8px 14px', fontSize: 12, fontWeight: 800, cursor: 'pointer', fontFamily: 'inherit' }}>📋 Copier</button>
                  </div>
                </>
              );
            })()}
          </div>
        )}
        {coupon && (
          <div style={{ margin: '18px auto 0', maxWidth: 340, background: '#FFFBEB', border: '2px dashed #F59E0B', borderRadius: 14, padding: '14px 18px' }}>
            <div style={{ fontSize: 13, fontWeight: 800, color: '#92400E' }}>🎁 Et parce que tout le monde gagne :</div>
            <div style={{ fontSize: 26, fontWeight: 900, letterSpacing: '.15em', color: '#1F2937', margin: '6px 0' }}>{coupon}</div>
            <div style={{ fontSize: 12, color: '#78350F', lineHeight: 1.5 }}>{rewardText || 'Montrez ce code en magasin.'}</div>
            <div style={{ fontSize: 10.5, color: '#B45309', marginTop: 6 }}>📸 Fais une capture d'écran pour ne pas le perdre !</div>
          </div>
        )}
      </div>
    );
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    if (preview) return;
    if (!consent) { setErr(granular ? 'Merci d\'accepter le règlement pour participer.' : 'Merci de cocher la case de consentement pour valider votre inscription.'); return; }
    let bd = birthDate || null;
    if (config.birthdate_year_optional && config.show_birthdate) {
      if (config.birthdate_required && (!bDay || !bMonth)) { setErr('Merci d\'indiquer au moins le jour et le mois de naissance.'); return; }
      // Année facultative : sentinelle 1904 = « année inconnue » (les vœux marchent, l'âge reste inconnu)
      bd = bDay && bMonth ? `${bYear || '1904'}-${String(bMonth).padStart(2, '0')}-${String(bDay).padStart(2, '0')}` : null;
    }
    setErr('');
    onSubmit({
      first_name: firstName, last_name: lastName, email,
      birth_date: bd, phone,
      address, postal_code: postalCode, city,
      message, consent: true,
      ...(granular ? { consent_email: consentEmail, consent_sms: consentSms } : {}),
    });
  };

  const inputStyle = {
    width: '100%', padding: '12px 14px', borderRadius: 10,
    border: '1.5px solid #E5E7EB', fontSize: 14,
    fontFamily: 'inherit', boxSizing: 'border-box', outline: 'none',
    transition: 'border-color .15s', marginBottom: 10,
  };
  const companyName = config.company_name || 'notre entreprise';

  return (
    <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column' }}>
      {config.form_title && (
        <div style={{ fontSize: 17, fontWeight: 800, color: '#1F2937', marginBottom: 16 }}>
          {config.form_title}
        </div>
      )}
      {config.show_name && (
        <div style={{ display: 'flex', gap: 10 }}>
          <input type="text" placeholder="Prénom *" value={firstName} onChange={e => setFirstName(e.target.value)} style={inputStyle} autoComplete="given-name" required />
          <input type="text" placeholder="Nom" value={lastName} onChange={e => setLastName(e.target.value)} style={inputStyle} autoComplete="family-name" />
        </div>
      )}
      <input
        type="email" placeholder="Votre adresse email *" required
        value={email} onChange={e => setEmail(e.target.value)}
        style={{ ...inputStyle, borderColor: '#A78BFA' }}
        autoComplete="email"
      />
      {config.show_birthdate && (
        <div style={{ marginBottom: 10 }}>
          <label style={{ fontSize: 12, color: '#6B7280', fontWeight: 600, display: 'block', marginBottom: 4 }}>
            🎂 Date de naissance {config.birthdate_required ? '*' : ''}
          </label>
          {config.birthdate_year_optional ? (
            <div style={{ display: 'flex', gap: 8 }}>
              <select value={bDay} onChange={e => setBDay(e.target.value)} required={!!config.birthdate_required}
                style={{ ...inputStyle, marginBottom: 0, flex: 1 }} aria-label="Jour de naissance">
                <option value="">Jour</option>
                {Array.from({ length: 31 }, (_, i) => <option key={i + 1} value={i + 1}>{i + 1}</option>)}
              </select>
              <select value={bMonth} onChange={e => setBMonth(e.target.value)} required={!!config.birthdate_required}
                style={{ ...inputStyle, marginBottom: 0, flex: 1.4 }} aria-label="Mois de naissance">
                <option value="">Mois</option>
                {['janvier','février','mars','avril','mai','juin','juillet','août','septembre','octobre','novembre','décembre'].map((m, i) => <option key={m} value={i + 1}>{m}</option>)}
              </select>
              <select value={bYear} onChange={e => setBYear(e.target.value)}
                style={{ ...inputStyle, marginBottom: 0, flex: 1.1 }} aria-label="Année de naissance (facultative)">
                <option value="">Année (facultatif)</option>
                {Array.from({ length: 100 }, (_, i) => { const y = new Date().getFullYear() - 14 - i; return <option key={y} value={y}>{y}</option>; })}
              </select>
            </div>
          ) : (
            <input
              type="date" value={birthDate} onChange={e => setBirthDate(e.target.value)}
              style={{ ...inputStyle, marginBottom: 0 }} required={!!config.birthdate_required}
              max={new Date().toISOString().split('T')[0]}
            />
          )}
          {config.birthdate_year_optional && (
            <div style={{ fontSize: 10.5, color: '#9CA3AF', marginTop: 3 }}>Le jour et le mois suffisent pour l'attention d'anniversaire — l'année est facultative.</div>
          )}
        </div>
      )}
      {config.show_phone && (
        <input
          type="tel" placeholder="Votre téléphone" value={phone}
          onChange={e => setPhone(e.target.value)} style={inputStyle} autoComplete="tel"
        />
      )}
      {config.show_address && (
        <>
          <input type="text" placeholder="Adresse" value={address} onChange={e => setAddress(e.target.value)} style={inputStyle} autoComplete="street-address" />
          <div style={{ display: 'flex', gap: 10 }}>
            <input type="text" placeholder="NPA" value={postalCode} onChange={e => setPostal(e.target.value)} style={{ ...inputStyle, flex: '0 0 90px' }} autoComplete="postal-code" />
            <input type="text" placeholder="Ville" value={city} onChange={e => setCity(e.target.value)} style={{ ...inputStyle, flex: 1 }} autoComplete="address-level2" />
          </div>
        </>
      )}
      {config.show_message && (
        <textarea
          placeholder={config.message_placeholder || 'Votre message…'}
          value={message} onChange={e => setMessage(e.target.value)}
          rows={3}
          style={{ ...inputStyle, resize: 'vertical', marginBottom: 10 }}
        />
      )}

      {/* Consentements — granulaires (concours v2) ou unique (autres gabarits) */}
      {granular ? (
        <div style={{ margin: '2px 0 12px', display: 'flex', flexDirection: 'column', gap: 7 }}>
          <label style={{ display: 'flex', gap: 8, alignItems: 'flex-start', fontSize: 12, color: '#374151', cursor: 'pointer', lineHeight: 1.5 }}>
            <input type="checkbox" checked={consent} onChange={e => setConsent(e.target.checked)} required style={{ marginTop: 2, accentColor: accent, flexShrink: 0 }} />
            <span><b>{config.consent_participation_text}</b> *</span>
          </label>
          <label style={{ display: 'flex', gap: 8, alignItems: 'flex-start', fontSize: 12, color: '#6B7280', cursor: 'pointer', lineHeight: 1.5 }}>
            <input type="checkbox" checked={consentEmail} onChange={e => setConsentEmail(e.target.checked)} style={{ marginTop: 2, accentColor: accent, flexShrink: 0 }} />
            <span>{config.consent_email_text}</span>
          </label>
          {config.show_phone && config.consent_sms_text && (
            <label style={{ display: 'flex', gap: 8, alignItems: 'flex-start', fontSize: 12, color: '#6B7280', cursor: 'pointer', lineHeight: 1.5 }}>
              <input type="checkbox" checked={consentSms} onChange={e => setConsentSms(e.target.checked)} style={{ marginTop: 2, accentColor: accent, flexShrink: 0 }} />
              <span>{config.consent_sms_text}</span>
            </label>
          )}
        </div>
      ) : (
      <label style={{ display: 'flex', gap: 8, alignItems: 'flex-start', fontSize: 12, color: '#6B7280', margin: '2px 0 12px', cursor: 'pointer', lineHeight: 1.5 }}>
        <input type="checkbox" checked={consent} onChange={e => setConsent(e.target.checked)} style={{ marginTop: 2, accentColor: accent, flexShrink: 0 }} />
        <span>
          J'accepte que <strong>{companyName}</strong> conserve mes coordonnées pour me recontacter
          {config.show_birthdate ? " et m'adresser des attentions personnalisées (dont mon anniversaire)" : ''}.
          Je pourrai me désinscrire à tout moment.
        </span>
      </label>
      )}
      {err && <div style={{ fontSize: 12, color: '#DC2626', marginBottom: 8 }}>⚠️ {err}</div>}

      <button
        type="submit"
        disabled={submitting}
        style={{
          background: accent, color: '#fff', border: 'none',
          borderRadius: 12, padding: '14px 24px', fontSize: 15,
          fontWeight: 800, cursor: submitting ? 'not-allowed' : 'pointer',
          opacity: submitting ? 0.7 : 1, transition: 'opacity .15s',
          marginTop: 4,
        }}
      >
        {submitting ? '⏳ Envoi en cours…' : config.cta_text || 'S\'inscrire'}
      </button>
      <div style={{ fontSize: 11, color: '#9CA3AF', textAlign: 'center', marginTop: 8 }}>
        🔒 Vos données sont confidentielles — aucun spam.
      </div>
    </form>
  );
}

// ── ✏️ Édition en place (builder) : clic sur le texte → on tape dedans ────────
// Non contrôlé pendant la frappe (contentEditable), commit au blur → pas de
// re-render qui vole le curseur. Échap = annule la frappe en cours.
export function Ed({ k, config, onEdit, style, children }) {
  if (!onEdit) return children ?? (config[k] || '');
  return (
    <span
      contentEditable
      suppressContentEditableWarning
      title="✏️ Clique pour modifier — Échap pour annuler"
      onFocus={e => { e.currentTarget.dataset.prev = e.currentTarget.innerText; }}
      onKeyDown={e => {
        if (e.key === 'Escape') { e.currentTarget.innerText = e.currentTarget.dataset.prev || ''; e.currentTarget.blur(); }
        if (e.key === 'Enter' && k !== 'description' && k !== 'rules') { e.preventDefault(); e.currentTarget.blur(); }
      }}
      onBlur={e => {
        const v = e.currentTarget.innerText.trim();
        if (v !== (config[k] || '')) onEdit(k, v);
      }}
      style={{ outline: 'none', cursor: 'text', borderBottom: '1.5px dashed rgba(255,255,255,.45)', ...style }}
    >{config[k] || ''}</span>
  );
}

// ── Template renderers ────────────────────────────────────────────────────────

export function TemplateLeadMagnet({ config, onSubmit, submitting, success, preview, onEditField }) {
  const accent = config.accent_color || '#6428F4';
  const bg     = config.bg_color     || '#F5F3FF';
  return (
    <div style={{ minHeight: preview ? 'auto' : '100vh', background: bg, fontFamily: "'Inter','Segoe UI',sans-serif" }}>
      {/* Hero */}
      <div style={{ background: `linear-gradient(135deg,${accent},#C93DB0)`, padding: preview ? '28px 24px' : '56px 24px', textAlign: 'center' }}>
        {config.logo_url && <img src={config.logo_url} alt="logo" style={{ height: 40, marginBottom: 16, objectFit: 'contain' }} />}
        {config.badge_text && (
          <div style={{ display: 'inline-block', background: '#FEF9C3', color: '#92400E', fontWeight: 800, fontSize: 12, borderRadius: 20, padding: '4px 14px', marginBottom: 16, letterSpacing: 1 }}>
            🎁 {config.badge_text}
          </div>
        )}
        <h1 style={{ color: '#fff', fontSize: preview ? 20 : 34, fontWeight: 900, margin: '0 0 12px', lineHeight: 1.2 }}><Ed k="headline" config={config} onEdit={onEditField} /></h1>
        <p style={{ color: 'rgba(255,255,255,.88)', fontSize: preview ? 13 : 18, margin: 0, maxWidth: 520, marginInline: 'auto' }}>{config.subheadline}</p>
      </div>
      {/* Body */}
      <div style={{ maxWidth: 860, margin: '0 auto', padding: preview ? '20px 16px' : '48px 24px', display: 'flex', gap: 40, flexWrap: 'wrap', alignItems: 'flex-start' }}>
        {/* Left */}
        <div style={{ flex: '1 1 320px' }}>
          {config.resource_name && (
            <div style={{ background: '#fff', borderRadius: 16, padding: '20px 24px', boxShadow: '0 4px 24px rgba(0,0,0,.08)', marginBottom: 24, borderLeft: `4px solid ${accent}` }}>
              <div style={{ fontSize: 12, color: accent, fontWeight: 700, marginBottom: 6, textTransform: 'uppercase' }}>Ce que vous recevez</div>
              <div style={{ fontSize: preview ? 16 : 22, fontWeight: 800, color: '#1F2937' }}>📘 {config.resource_name}</div>
            </div>
          )}
          {config.description && <p style={{ fontSize: preview ? 13 : 16, color: '#374151', lineHeight: 1.7, marginBottom: 20 }}>{config.description}</p>}
          {(config.bullets || []).filter(Boolean).map((b, i) => (
            <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: 10, marginBottom: 10 }}>
              <span style={{ color: accent, fontWeight: 900, fontSize: 16, marginTop: 1, flexShrink: 0 }}>✓</span>
              <span style={{ fontSize: preview ? 13 : 15, color: '#374151' }}>{b}</span>
            </div>
          ))}
          {config.company_name && <div style={{ marginTop: 24, fontSize: 13, color: '#9CA3AF' }}>— {config.company_name}</div>}
        </div>
        {/* Form */}
        <div style={{ flex: '1 1 280px', background: '#fff', borderRadius: 20, padding: '28px 28px', boxShadow: '0 8px 40px rgba(0,0,0,.1)' }}>
          <LandingForm config={config} onSubmit={onSubmit} submitting={submitting} success={success} preview={preview} />
        </div>
      </div>
    </div>
  );
}

export function TemplatePromo({ config, onSubmit, submitting, success, preview, onEditField }) {
  const accent = config.accent_color || '#DC2626';
  const bg     = config.bg_color     || '#FFF7ED';
  return (
    <div style={{ minHeight: preview ? 'auto' : '100vh', background: bg, fontFamily: "'Inter','Segoe UI',sans-serif" }}>
      <div style={{ background: `linear-gradient(135deg,${accent},#F59E0B)`, padding: preview ? '28px 24px' : '56px 24px', textAlign: 'center' }}>
        {config.logo_url && <img src={config.logo_url} alt="logo" style={{ height: 40, marginBottom: 16, objectFit: 'contain' }} />}
        {config.discount_text && (
          <div style={{ display: 'inline-block', background: '#fff', color: accent, fontWeight: 900, fontSize: preview ? 28 : 48, borderRadius: 20, padding: '8px 28px', marginBottom: 16, boxShadow: '0 4px 20px rgba(0,0,0,.15)' }}>
            {config.discount_text}
          </div>
        )}
        <h1 style={{ color: '#fff', fontSize: preview ? 18 : 32, fontWeight: 900, margin: '0 0 10px', lineHeight: 1.2 }}>{config.headline}</h1>
        <p style={{ color: 'rgba(255,255,255,.9)', fontSize: preview ? 12 : 16, margin: 0 }}>{config.subheadline}</p>
        {config.validity_text && (
          <div style={{ display: 'inline-block', marginTop: 12, background: 'rgba(0,0,0,.25)', color: '#fff', borderRadius: 20, padding: '5px 16px', fontSize: 13, fontWeight: 600 }}>
            ⏰ {config.validity_text}
          </div>
        )}
      </div>
      <div style={{ maxWidth: 860, margin: '0 auto', padding: preview ? '20px 16px' : '48px 24px', display: 'flex', gap: 40, flexWrap: 'wrap', alignItems: 'flex-start' }}>
        <div style={{ flex: '1 1 320px' }}>
          {config.description && <p style={{ fontSize: preview ? 13 : 16, color: '#374151', lineHeight: 1.7, marginBottom: 20 }}>{config.description}</p>}
          {(config.bullets || []).filter(Boolean).map((b, i) => (
            <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: 10, marginBottom: 10 }}>
              <span style={{ color: accent, fontWeight: 900, fontSize: 16, marginTop: 1, flexShrink: 0 }}>✓</span>
              <span style={{ fontSize: preview ? 13 : 15, color: '#374151' }}>{b}</span>
            </div>
          ))}
          {config.company_name && <div style={{ marginTop: 24, fontSize: 13, color: '#9CA3AF' }}>— {config.company_name}</div>}
        </div>
        <div style={{ flex: '1 1 280px', background: '#fff', borderRadius: 20, padding: '28px 28px', boxShadow: '0 8px 40px rgba(0,0,0,.1)' }}>
          <LandingForm config={config} onSubmit={onSubmit} submitting={submitting} success={success} preview={preview} />
        </div>
      </div>
    </div>
  );
}

export function TemplateEvent({ config, onSubmit, submitting, success, preview, onEditField }) {
  const accent = config.accent_color || '#0EA5E9';
  const bg     = config.bg_color     || '#F0F9FF';
  return (
    <div style={{ minHeight: preview ? 'auto' : '100vh', background: bg, fontFamily: "'Inter','Segoe UI',sans-serif" }}>
      <div style={{ background: `linear-gradient(135deg,${accent},#6366F1)`, padding: preview ? '28px 24px' : '56px 24px', textAlign: 'center' }}>
        {config.logo_url && <img src={config.logo_url} alt="logo" style={{ height: 40, marginBottom: 16, objectFit: 'contain' }} />}
        {config.event_name && (
          <div style={{ display: 'inline-block', background: 'rgba(255,255,255,.2)', color: '#fff', borderRadius: 20, padding: '5px 18px', fontSize: 13, fontWeight: 700, marginBottom: 14 }}>
            🎉 {config.event_name}
          </div>
        )}
        <h1 style={{ color: '#fff', fontSize: preview ? 18 : 32, fontWeight: 900, margin: '0 0 12px', lineHeight: 1.2 }}>{config.headline}</h1>
        <p style={{ color: 'rgba(255,255,255,.88)', fontSize: preview ? 12 : 16, margin: '0 0 16px' }}>{config.subheadline}</p>
        {(config.event_date || config.event_location) && (
          <div style={{ display: 'inline-flex', gap: 20, background: 'rgba(0,0,0,.2)', borderRadius: 12, padding: '10px 20px', color: '#fff', fontSize: 14 }}>
            {config.event_date && <span>📅 {config.event_date}</span>}
            {config.event_location && <span>📍 {config.event_location}</span>}
          </div>
        )}
      </div>
      <div style={{ maxWidth: 860, margin: '0 auto', padding: preview ? '20px 16px' : '48px 24px', display: 'flex', gap: 40, flexWrap: 'wrap', alignItems: 'flex-start' }}>
        <div style={{ flex: '1 1 320px' }}>
          {config.description && <p style={{ fontSize: preview ? 13 : 16, color: '#374151', lineHeight: 1.7, marginBottom: 20 }}>{config.description}</p>}
          {(config.bullets || []).filter(Boolean).map((b, i) => (
            <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: 10, marginBottom: 10 }}>
              <span style={{ color: accent, fontWeight: 900, fontSize: 16, marginTop: 1, flexShrink: 0 }}>✓</span>
              <span style={{ fontSize: preview ? 13 : 15, color: '#374151' }}>{b}</span>
            </div>
          ))}
          {config.company_name && <div style={{ marginTop: 24, fontSize: 13, color: '#9CA3AF' }}>— {config.company_name}</div>}
        </div>
        <div style={{ flex: '1 1 280px', background: '#fff', borderRadius: 20, padding: '28px 28px', boxShadow: '0 8px 40px rgba(0,0,0,.1)' }}>
          <LandingForm config={config} onSubmit={onSubmit} submitting={submitting} success={success} preview={preview} />
        </div>
      </div>
    </div>
  );
}

export function TemplateDiagnostic({ config, onSubmit, submitting, success, preview, onEditField }) {
  const accent = config.accent_color || '#059669';
  const bg     = config.bg_color     || '#F0FDF4';
  return (
    <div style={{ minHeight: preview ? 'auto' : '100vh', background: bg, fontFamily: "'Inter','Segoe UI',sans-serif" }}>
      <div style={{ background: `linear-gradient(135deg,${accent},#0EA5E9)`, padding: preview ? '28px 24px' : '56px 24px', textAlign: 'center' }}>
        {config.logo_url && <img src={config.logo_url} alt="logo" style={{ height: 40, marginBottom: 16, objectFit: 'contain' }} />}
        <div style={{ display: 'inline-block', background: 'rgba(255,255,255,.2)', color: '#fff', borderRadius: 20, padding: '5px 18px', fontSize: 13, fontWeight: 700, marginBottom: 14 }}>
          🔍 {config.offer_name || 'Diagnostic gratuit'}
        </div>
        <h1 style={{ color: '#fff', fontSize: preview ? 18 : 32, fontWeight: 900, margin: '0 0 12px', lineHeight: 1.2 }}>{config.headline}</h1>
        <p style={{ color: 'rgba(255,255,255,.88)', fontSize: preview ? 12 : 16, margin: 0 }}>{config.subheadline}</p>
      </div>
      <div style={{ maxWidth: 860, margin: '0 auto', padding: preview ? '20px 16px' : '48px 24px', display: 'flex', gap: 40, flexWrap: 'wrap', alignItems: 'flex-start' }}>
        <div style={{ flex: '1 1 320px' }}>
          {config.description && <p style={{ fontSize: preview ? 13 : 16, color: '#374151', lineHeight: 1.7, marginBottom: 20 }}>{config.description}</p>}
          {(config.bullets || []).filter(Boolean).map((b, i) => (
            <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: 10, marginBottom: 10 }}>
              <span style={{ color: accent, fontWeight: 900, fontSize: 16, marginTop: 1, flexShrink: 0 }}>✓</span>
              <span style={{ fontSize: preview ? 13 : 15, color: '#374151' }}>{b}</span>
            </div>
          ))}
          {config.company_name && <div style={{ marginTop: 24, fontSize: 13, color: '#9CA3AF' }}>— {config.company_name}</div>}
        </div>
        <div style={{ flex: '1 1 280px', background: '#fff', borderRadius: 20, padding: '28px 28px', boxShadow: '0 8px 40px rgba(0,0,0,.1)' }}>
          <LandingForm config={config} onSubmit={onSubmit} submitting={submitting} success={success} preview={preview} />
        </div>
      </div>
    </div>
  );
}

export function TemplateConcours({ config, onSubmit, submitting, success, preview, onEditField }) {
  const accent = config.accent_color || '#C026D3';
  const bg     = config.bg_color     || '#FDF4FF';
  return (
    <div style={{ minHeight: preview ? 'auto' : '100vh', background: bg, fontFamily: "'Inter','Segoe UI',sans-serif" }}>
      {/* Hero */}
      <div style={{ background: `linear-gradient(135deg,${accent},#F59E0B)`, padding: preview ? '28px 24px' : '56px 24px', textAlign: 'center' }}>
        {config.logo_url && <img src={config.logo_url} alt="logo" style={{ height: 40, marginBottom: 16, objectFit: 'contain' }} />}
        {config.badge_text && (
          <div style={{ display: 'inline-block', background: '#FEF9C3', color: '#92400E', fontWeight: 800, fontSize: 12, borderRadius: 20, padding: '4px 14px', marginBottom: 16, letterSpacing: 1 }}>
            🎁 {config.badge_text}
          </div>
        )}
        <h1 style={{ color: '#fff', fontSize: preview ? 20 : 34, fontWeight: 900, margin: '0 0 12px', lineHeight: 1.2 }}><Ed k="headline" config={config} onEdit={onEditField} /></h1>
        <p style={{ color: 'rgba(255,255,255,.9)', fontSize: preview ? 13 : 18, margin: 0, maxWidth: 520, marginInline: 'auto' }}><Ed k="subheadline" config={config} onEdit={onEditField} /></p>
        {config.end_text && (
          <div style={{ display: 'inline-block', marginTop: 14, background: 'rgba(0,0,0,.22)', color: '#fff', borderRadius: 20, padding: '5px 16px', fontSize: 13, fontWeight: 600 }}>
            ⏰ <Ed k="end_text" config={config} onEdit={onEditField} />
          </div>
        )}
      </div>
      {/* Body */}
      <div style={{ maxWidth: 860, margin: '0 auto', padding: preview ? '20px 16px' : '48px 24px', display: 'flex', gap: 40, flexWrap: 'wrap', alignItems: 'flex-start' }}>
        {/* Left */}
        <div style={{ flex: '1 1 320px' }}>
          {config.prize_name && (
            <div style={{ background: '#fff', borderRadius: 16, padding: '20px 24px', boxShadow: '0 4px 24px rgba(0,0,0,.08)', marginBottom: 24, borderLeft: `4px solid ${accent}` }}>
              <div style={{ fontSize: 12, color: accent, fontWeight: 700, marginBottom: 6, textTransform: 'uppercase' }}>À gagner</div>
              {config.prize_image_url && (
                <img src={config.prize_image_url} alt="Le lot à gagner"
                  style={{ width: '100%', maxHeight: preview ? 140 : 260, objectFit: 'cover', borderRadius: 12, marginBottom: 12 }} />
              )}
              <div style={{ fontSize: preview ? 16 : 22, fontWeight: 800, color: '#1F2937' }}>🏆 <Ed k="prize_name" config={config} onEdit={onEditField} style={{ borderBottomColor: 'rgba(0,0,0,.25)' }} /></div>
              {config.prize_value && <div style={{ fontSize: 13, color: '#6B7280', marginTop: 4 }}>Valeur : {config.prize_value}</div>}
            </div>
          )}
          {config.description && <p style={{ fontSize: preview ? 13 : 16, color: '#374151', lineHeight: 1.7, marginBottom: 20 }}>{config.description}</p>}
          {(config.bullets || []).filter(Boolean).map((b, i) => (
            <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: 10, marginBottom: 10 }}>
              <span style={{ color: accent, fontWeight: 900, fontSize: 16, marginTop: 1, flexShrink: 0 }}>✓</span>
              <span style={{ fontSize: preview ? 13 : 15, color: '#374151' }}>{b}</span>
            </div>
          ))}
          {config.company_name && <div style={{ marginTop: 24, fontSize: 13, color: '#9CA3AF' }}>— {config.company_name}</div>}
        </div>
        {/* Form */}
        <div style={{ flex: '1 1 280px', background: '#fff', borderRadius: 20, padding: '28px 28px', boxShadow: '0 8px 40px rgba(0,0,0,.1)' }}>
          <LandingForm config={config} onSubmit={onSubmit} submitting={submitting} success={success} preview={preview} />
        </div>
      </div>
      {/* Règlement */}
      {config.rules && (
        <div style={{ maxWidth: 860, margin: '0 auto', padding: preview ? '0 16px 20px' : '0 24px 48px' }}>
          <details style={{ background: '#fff', borderRadius: 12, padding: '12px 18px', fontSize: 12, color: '#6B7280', border: '1px solid #F3E8FF' }}>
            <summary style={{ cursor: 'pointer', fontWeight: 700, color: '#374151' }}>📜 Règlement du jeu</summary>
            <p style={{ marginTop: 10, lineHeight: 1.6 }}>{config.rules}</p>
          </details>
        </div>
      )}
    </div>
  );
}

export const RENDERERS = {
  lead_magnet: TemplateLeadMagnet,
  promo:       TemplatePromo,
  event:       TemplateEvent,
  diagnostic:  TemplateDiagnostic,
  concours:    TemplateConcours,
};

export function renderTemplate(templateId, props) {
  const Comp = RENDERERS[templateId] || TemplateLeadMagnet;
  return <Comp {...props} />;
}
